export const ErrorHandler = (error) => {
  if (error?.response) {
    if (error?.response?.status === 401) {
      const token = localStorage.getItem("user");
      localStorage.clear();
      window.location.reload();
      if (token) {
        localStorage.clear();
        window.location.reload();
      }
    } else if (error?.response?.status === 500) {
      return error?.response?.statusText;
    }
    return error?.response?.data?.message;
  } else if (error?.request) {
    return error?.message;
  } else {
    return "Something went wrong";
  }
};